import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UserShippingAddress } from '../../../models/shopping';
import { User } from '../../../models/user';
import { AuthService } from '../../../services/auth.service';
import { SelectUserShippingAddressDialog } from '../select-user-shipping-address-dialog/select-user-shipping-address-dialog';

@Component({
  selector: 'app-select-user-shipping-address-button',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './select-user-shipping-address-button.html',
  styleUrl: './select-user-shipping-address-button.scss',
})
export class SelectUserShippingAddressButton {
  @Output() onSelected = new EventEmitter<UserShippingAddress>();
  constructor(private dialog: MatDialog, private authService: AuthService) {}

  get profile(): User | null {
    return this.authService.profile();
  }

  open() {
    this.dialog
      .open(SelectUserShippingAddressDialog, {
        width: '480px',
      })
      .afterClosed()
      .subscribe((addr) => {
        if (addr) {
          this.onSelected.emit(addr);
        }
      });
  }
}
